import { GetStaticProps, NextPage } from 'next'
import dynamic from 'next/dynamic'
import React, { memo } from 'react'
import { Footer } from 'src/components/Footer/Footer'
import MainContainer from 'src/components/global/MainContainer/MainContainer'
import { ThemeOnly } from 'src/components/global/ThemeOnly'
import SkeletonLoading from 'src/components/SkeletonLoading/SkeletonLoading'
import { THEME } from 'src/config/config'
import { basicPlanFeatures, vendorPlanFeatures } from 'src/constants/constants'
import { Meta } from 'src/layout/Meta'
import { Main } from 'src/templates/Main'

const PricingPanel = memo(
  dynamic(() => import('src/components/global/PricingPanel/PricingPanel').then((mod) => mod.PricingPanel), {
    ssr: false,
    loading: () => <SkeletonLoading className="bg-navy" />,
  }),
)

const Pricing: NextPage = () => {
  const title = 'Legaltech Hub'
  const description = 'Legaltech Hub - Choose an account type to get started'

  return (
    <Main meta={<Meta title={title} description={description} url="/registration/" />}>
      <MainContainer id="mainContainer-1">
        <div id="mainContainer-2" className="mainContianer flex flex-col min-h-screen">
          <div className="flex flex-grow">
            {/* Left section with background image */}
            <section className="bg-navy w-[30%] p-5 md:pl-[70px] md:pr-[50px] md:pt-[50px] bg-cover bg-banner-registration">
              <div className="flex flex-col justify-center h-full">
                <h1 className="text-white text-[30px] font-bold font-secondary">Sign Up</h1>
                <h2 className="text-white text-[16px] font-bold mt-2">
                  Choose the account type that is right for you.
                </h2>
              </div>
            </section>

            {/* Right section with content */}
            <div className="w-[70%] flex flex-col items-center justify-center bg-white px-5 py-10">
              <div className="flex flex-wrap items-center justify-center max-w-[900px] w-full px-5 md:px-[20px]">
                <PricingPanel
                  key={'basicPlanFeatures-1'}
                  className="flex flex-col md:mr-[40px] mt-[21px]"
                  type="I'm an individual user"
                  description="Sign up for a free account that allows you to work with the directory."
                  // cost="No Cost"
                  options={basicPlanFeatures}
                  isAvailable={true}
                  buttonName="Sign Up as a User"
                  targetPath="/signup"
                  isHtml={true}
                />

                <PricingPanel
                  className="flex flex-col md:mr-[40px] mt-[21px]"
                  type="I'm a vendor"
                  description="Providers of legal technology products and services."
                  // cost="Request quote"
                  // optionLabel="Create an account to:"
                  options={vendorPlanFeatures}
                  buttonName="Sign Up as a Vendor"
                  targetPath="/signup-vendor"
                  isAvailable={true}
                />
              </div>
            </div>
          </div>

          <ThemeOnly theme="legaltech">
            <Footer />
          </ThemeOnly>
        </div>
      </MainContainer>
    </Main>
  )
}

export default Pricing

export const getStaticProps: GetStaticProps = () => {
  if (THEME === 'ilta')
    return {
      revalidate: 60,
      notFound: true,
    }

  return {
    props: {},
    revalidate: 60,
  }
}
